export class TranslationObject {
  public static TRANSLATION_OBJECT = {
    //app-component.html
    SalesEmails: 'Sales-Emails',
    WasGibtsNeues: "Was gibt's neues?",
    NeustartTutorial: 'Neustart-Tutorial',
    HowToVideos: 'How-to Videos',
    Hilfe: 'Hilfe',
    Dokumentation: 'Dokumentation',
    MONASupport: 'MONA-Support',
    MONAAutomations: 'MONA-Automationen',
    Datatransfer: 'Datatransfer',
    Neu: 'Neu',
    //add-node-popover.html
    Dashboard: 'Dashboard',
    Löschen: 'Löschen',
    Abbrechen: 'Abbrechen',
    Ok: 'Ok',
    Bedingung: 'Bedingung',
    Ja: 'Ja',
    Nein: 'Nein',
    gleich: 'gleich',
    ungleich: 'ungleich',
    größergleich: 'größer gleich',
    kleinergleich: 'kleiner gleich',
    keineBedingung: 'keine Bedingung',
    Antwort: 'Antwort',
    keineAntworten: 'keine Antworten',
    Aktion: 'Aktion',
    keineAktion: 'keine Action',
    Verbindenmit: 'Verbinden mit',
    VerbindenMitMussGefülltsein: 'Verbinden mit muss gefüllt sein.',

    //assessment-test-information.html
    FrageFürDieBewertungHinzufügen: 'Frage für die Bewertung hinzufügen',
    GebenSieEinenTitelFürDieFeststellungsprüfungAn:
      'Geben Sie einen Titel für den Einstellungstest an',
    GebenSieEineBewertungsfrageEin: 'Geben Sie eine Bewertungsfrage ein',
    Frage: 'Frage',
    RichtigeAntwort: 'Richtige Antwort',
    FalscheAntwort: 'Falsche Antwort',
    WerkzeugeBearbeiten: 'Werkzeuge bearbeiten',
    TestGenerieren: 'Test generieren',
    UpdateTest: 'Test aktualisieren',

    //assessment-test.html
    AssessmentTestErstellen: 'Einstellungstest erstellen',
    AssessmentTitle: 'Titel',

    //new-assessment-test.html
    DerTitelExistiertBereitsErstellenSieEinenEinzigartigenTitel:
      'Der Titel existiert bereits. Erstellen Sie einen einzigartigen Titel.',

    //create-workflow.html
    BasicWorkflows: 'Grundlegende Workflows',
    UseWorkflow: 'Workflow verwenden',
    AdvancedWorkflows: 'Erweiterte Workflows',
    NeuenWorkflowErstellen: 'Neuen Workflow erstellen',
    EmailSendenBeiBewerbungseingang: 'Email senden bei Bewerbungseingang',
    sendeEineEmailWennBineBewerbungEingegangenIst:
      'sende eine Email, wenn eine Bewerbung eingegangen ist',
    EmailSendenWennBewerberImOnboardingIst:
      'Email senden wenn Bewerber im Onboarding ist',
    sendeEineEmailWennSichDerBewerbendeImOnboardingBefindet:
      'sende eine Email, wenn sich der Bewerbende im Onboarding befindet',
    ProfilAnKundeVerschicken: 'Profil an Kunde verschicken',
    sendeEineEmailMitDemBewerberprofilAnDenKunden:
      'sende eine Email mit dem Bewerberprofil an den Kunden',
    ProfilAnDisponentVerschicken: 'Profil an Disponent verschicken',
    sendeEineEmailMitDemBewerberprofilAnDenDisponenten:
      'sende eine Email mit dem Bewerberprofil an den Disponenten',
    MatcheBewerberAufKriteriumSendeNotizAnDisponenten:
      'Matche Bewerber auf Kriterium, sende Notiz an Disponenten',
    SchickeInformationenNachErfolgreichemInterview:
      'Schicke Informationen nach erfolgreichem Interview',
    schickeSpezifischeInformationenZumBewerberDamitManWeißWieEsWeitergeht:
      'schicke spezifische Informationen zum Bewerber, damit man weiß, wie es weitergeht.',
    SchickeDatenAnSchnittstellen: 'Schicke Daten an Schnittstellen',
    updateInformationenInATSSystem: 'update Informationen in ATS-System',
    fahreEchtzeitUpdatesInDeinemATSSystem:
      'fahre Echtzeit-Updates in deinem ATS-System',
    updateInformationenInERPSystem: 'update Informationen in ERP-System',
    fahreEchtzeitUpdatesInDeinemERPSystem:
      'fahre Echtzeit-Updates in deinem ERP-System',
    leiteWeiterZurWebseite: 'leite weiter zur Webseite:',
    leiteDiePersonWeiterZuEinerWebseite:
      'leite die Person weiter zu einer Webseite',
    ProfilErstellenNachBewerbungseingangOhneInterview:
      'Profil erstellen nach Bewerbungseingang ohne Interview',
    erstelleEinProfilOhneInterview: 'erstelle ein Profil ohne Interview',
    ProfilMatchenUndVersendenAKunden: 'Profil matchen und versenden an Kunden',
    ProfilMatchenUndVersendenAnDisponent:
      'Profil matchen und versenden an Disponent',
    matcheUndVersendeDasProfilAnDenKunden:
      'matche und versende das Profil an den Kunden',
    AnrufSendenWennBewerberInsichBeworbenHat:
      'Anruf senden wenn Bewerber/-in sich beworben hat',
    sendeEinenAnrufWennDerBewerbendeDasOnboardingBeendetHat:
      'sende einen Anruf, wenn der Bewerbende das Onboarding beendet hat',
    SMSSendenWennBewerberInSichBeworbenHat:
      'SMS senden wenn Bewerber/-in sich beworben hat',
    sendeEineSMSWennDerBewerbendeDasOnboardingErfolgreichBeendetHat:
      'sende eine SMS, wenn der Bewerbende das Onboarding erfolgreich beendet hat',
    SendeDankesmailAnBewerber: 'Sende Dankesmail an Bewerber',
    sendetDankesmailAnBewerberNachDemBewerbungsprozess:
      'sendet Dankesmail an Bewerber nach dem Bewerbungsprozess',
    SendeVertragskopieAnBewerber: 'Sende Vertragskopie an Bewerber',
    sendetEineKopieDesVertragsAnDenBewerber:
      'sendet eine Kopie des Vertrags an den Bewerber',
    TerminÜberCalendlyBuchen: 'Termin buchen (z.B. Calendly oder Bookings)',
    DerBewerberKannEinenTerminÜberCalendlyBeiIhnenBuchen:
      'Der Bewerber kann einen Termin über Calendly bei Ihnen buchen.',
    TerminÜberURLBuchen: 'Termin buchen über URL',
    TerminÜberURLBuchenBeschreibung:
      'Der Bewerber kann einen Termin über URL bei Ihnen buchen.',
    InValidURL: 'Bitte geben Sie eine gültige URL ein.',

    zumZeitpunkt: 'zum Zeitpunkt',
    vierhDanach: '4h danach',
    vierundzwanzighDanach: '24h danach',
    achtundvierzighDanach: '48h danach',
    benutzerdefinierteZeit: 'benutzerdefinierte Zeit',
    BenutzerdefinierteZeit: 'Benutzerdefinierte Zeit',
    nichtWiederholen: 'nicht wiederholen',
    wiederholen: 'Wiederholen',
    every: 'jede',
    after: 'nach',
    PleaseEnteraNumberFrom1to30: 'Bitte geben Sie eine Zahl von 1 bis 30 ein.',
    täglich: 'täglich',
    wöchentlich: 'wöchentlich',
    monatlich: 'monatlich',
    mon: 'Mon',
    di: 'Di',
    mi: 'Mi',
    do: 'Do',
    fr: 'Fr',
    sa: 'Sa',
    so: 'So',
    Bewerberprofil: 'Bewerberprofil',
    BewerberprofilFürKunden: 'Bewerberprofil für Kunden',
    Vertragsdokumente: 'Vertragsdokumente',
    attachments: 'Anhänge',
    dynamicAttachments: 'Dynamische Anhänge',
    API: 'API',
    Flowchartknotenpunkt: 'Flowchart-Knotenpunkt',
    PromptWorkflow: 'Prompt-Workflow',
    agentWorkflow: 'Agent-Workflow',
    OnboardingBeendet: 'Onboarding beendet',
    WiederkehrenderWorkflow: 'Wiederkehrender Workflow',
    InterviewBeendet: 'Interview beendet',
    VertragUnterschrieben: 'Vertrag unterschrieben',
    mandantenMatchingEinzeln: 'Mandanten-Matching einzeln',
    geoMappingEinzeln: 'Geo-Mapping einzeln',
    geoMappingMehrfach: 'Geo-Mapping mehrfach',
    alleAusführen: 'alle ausführen',
    KriteriumErfüllt: 'Kriterium erfüllt',
    mehrereKriterienErfüllt: 'mehrere Kriterien erfüllt',
    Disponent: 'Disponent',
    Kunde: 'Kunde',

    //dashbaord.html (workflow dashboard)
    Workflows: 'Workflows',
    Name: 'Name',
    Inhalt: 'Inhalt',
    Medium: 'Medium',
    Zyklus: 'Zyklus',
    zumEreigniszeitpunkt: 'zum Ereigniszeitpunkt',
    nach4Stunden: 'nach 4 Stunden zw. 09:00-17:00 lokale Zeit',
    nach24Stunden: 'nach 24 Stunden zw. 09:00-17:00 lokale Zeit',
    nach48Stunden: 'nach 48 Stunden zw. 09:00-17:00 lokale Zeit',
    jederzeit: 'jederzeit',
    bewerberContingent: 'Bewerber-Contingent im Jahr',
    ZeitProBewerber: 'Zeit pro Bewerber',
    inMin: 'in min',
    StundenlohnDisponentEuro: 'Stundenlohn Disponent (€)',
    NoDocumentAvailable: 'Kein Dokument verfügbar',
    FileWithNoWorkflows: 'Datei enthält keine Workflows',
    Status: 'Status',

    //workflow-contact-modal.html
    AktionAuswählen: 'Aktion auswählen',
    BewerberAusgewählt: 'Bewerber ausgewählt',
    WorkflowAnwenden: 'Workflow anwenden',
    BestehendeWorkflowDatenWerdenÜberschrieben: 'Bestehende Workflow-Daten werden überschrieben',
    NeuKontaktieren: 'Neu kontaktieren',
    BewerberDuplizierenUndNeuZuordnen: 'Bewerber duplizieren und neu zuordnen',
    WorkflowAuswählen: 'Workflow auswählen',
    StellenausschreibungAuswählen: 'Stellenausschreibung auswählen',
    InterviewAuswählen: 'Interview auswählen',
    Ausführen: 'Ausführen',
    AktionAusführen: 'Aktion ausführen',
    DerAusgewählteWorkflowWirdAufAlleBewerberAngewendet: 'Der ausgewählte Workflow wird auf alle {{count}} Bewerber angewendet. Bestehende Workflow-Daten werden überschrieben.',
    FürJedenDerBewerberWirdEineKopieErstellt: 'Für jeden der {{count}} Bewerber wird eine Kopie erstellt und der ausgewählten Stellenausschreibung zugeordnet. Kommunikationshistorie wird zurückgesetzt.',
    BitteWählenSieAlleErforderlichenOptionenAus: 'Bitte wählen Sie alle erforderlichen Optionen aus.',
    EinzellkontaktierungInfo: 'Hier können einzelne Bewerber kontaktiert werden. Bewerber können nur kontaktiert werden, wenn Vorname, Nachname, Telefonnummer, E-Mail und das Interview gefüllt sind.',

    //edit-workflow.html
    WorkflowEdit: 'Workflow bearbeiten',
    UntergeordneteWorkflows: 'Untergeordnete Workflows',
    UntergeordneteMatchingOptionen: 'Untergeordnete Matching-Optionen',
    WorkflowName: 'Workflow Name',
    EventTypes: 'Welche Ereignistypen gelten für diesen Workflow?',
    bitteAuswählen: 'Bitte auswählen',
    BeschreibeDenProzess: 'Beschreibe den Prozess...',
    DateAndTime: 'Datum und Uhrzeit:',
    Repeat: 'Wiederholen:',
    Every: 'Jede:',
    days: 'Tage',
    weeks: 'Wochen',
    months: 'Monate',
    checkLogsForTranslation: 'Übersetze Antworten',
    End: 'Ende:',
    repeatations: 'Wiederholungen',
    WennDasPassiert: 'Wenn das passiert',
    StatusDesWorkflow: 'Status des Workflows',
    ChosenWorkflows: 'Gewählte Workflows',
    dannSchickeDiesesMedium: 'dann schicke dieses Medium',
    Informationen: 'Informationen',
    InformationenAnpassen: 'Informationen anpassen',
    EMailTextAnpassen: 'E-Mail-Text anpassen',
    Betreff: 'Betreff',
    Nachricht: 'Nachricht',
    Anhänge: 'Anhänge',
    BetreffFallsLleerDannWirdDerBetreffPassendDynamischGesetzt:
      'Betreff (falls leer, dann wird der Betreff passend dynamisch gesetzt)',
    DateiWählen: 'Datei wählen',
    dynamischeAnhänge: 'Dynamische Anhänge',
    NachrichtOptional: 'Nachricht (optional)',
    dynamischenAnhangAuswählen: 'Dynamischen Anhang auswählen',
    VorlageWählenOptional: 'Vorlage wählen (optional)',
    DokumentHochladenNurDOCX: 'Dokument hochladen (nur .docx)',
    dynamischeAPIDaten: 'Dynamische API-Daten',
    anDieseEmpfänger: 'An diese Empfänger',
    EMailAdresseDesEmpfängersUndAufPLUSklicken:
      'E-Mail Adresse des Empfängers und auf PLUS klicken',
    Landesvorwahl: 'Landesvorwahl',
    Telefonnummer: 'Telefonnummer',
    DieEMailExistiertBereits: 'Die E-Mail existiert bereits!',
    DieTelefonnummerExistiertBereits: 'Die Telefonnummer existiert bereits!',
    KalenderLink: 'Kalender Link',
    KalenderLinkEinfügen: 'Kalender Link einfügen',
    Speichern: 'Speichern',
    CustomizeReminderEmail: 'E-Mail Text',
    CustomizeReminderSMS: 'SMS Text',
    Prompt: 'Prompt',
    Agent: 'Agent',
    BewerberprofilFürDirektvertrieb: 'Bewerberprofil für Direktvertrieb',
    duplicateWorkflowText: 'Workflow-Name existiert bereits.',
    SchwellenwertOderLevel: 'Schwellenwert oder Level',

    //contacting-text.html
    EMailBetreff: 'E-Mail Betreff',
    HierKannDerStandardtextDesEMailBetreffsEingegebenWerden:
      'Hier kann der Standardtext des E-Mail Betreffs eingegeben werden.',
    EMailText: 'E-Mail Text',
    Vorname: 'Vorname',
    Nachname: 'Nachname',
    Firmenname: 'Firmenname',
    Link: 'Link',
    HierKannDerStandardtextZurEMailKontaktierungEingegebenWerden:
      'Hier kann der Standardtext zur E-Mail-Kontaktierung eingegeben werden.',
    SMSText: 'SMS Text',
    HierKannDerStandardtextZurSMSKontaktierungEingegebenWerden:
      'Hier kann der Standardtext zur SMS-Kontaktierung eingegeben werden.',

    //conditional-flowchart.html
    conditionalFlowchart: 'Flowchart',
    //dashbaord.html (workflow dashboard)
    //contract-information.html
    Lesen: 'Lesen',
    Messages: 'Nachrichten',
    Variables: 'Variablen',
    NeueNachrichtHinzufügen: 'Neue Nachricht hinzufügen',
    neueNachricht: 'neue Nachricht',
    VariabelMatching: 'Variabel Matching',
    VariableAusVertrag: 'Variable aus Vertrag',
    Konfigurieren: 'Konfigurieren',

    //contracts.html
    VertragHinzufügen: 'Vertrag hinzufügen',
    Vetragsname: 'Vertragsname',
    ErstelltAm: 'Erstellt am',

    //new-contract.html
    WähleEineDatei: 'Wähle eine Datei',
    aufCVAnalyseSchalten: 'auf CV Analyse schalten',
    aufVertragsAnalyseSchalten: 'auf Vertrags Analyse schalten',
    DragAndDropDateiHier: 'Drag and drop Datei hier',
    Erklärungen: 'Erklärungen',

    //dashboard.html
    MONADashboard: 'MONA-Dashboard',
    logout: 'Logout',
    aktuellerMonat: 'aktueller Monat',
    BewerberGesamt: 'Bewerber gesamt:',
    ZeitDisponent: 'Zeit Disponent:',
    Minuten: 'Minuten',
    ZeitMONA: 'Zeit MONA:',
    ZeitGespart: 'Zeit gespart:',
    GeldDisponent: 'Geld Disponent:',
    GeldGespart: 'Geld gespart:',
    loadingText: 'Wird geladen...',
    Bewerber: 'Bewerber',
    übergeordnet: 'übergeordnet',
    untergeordnet: 'untergeordnet',
    MaxLimit: 'Max Limit',
    BewerberDoppelpunkt: 'Bewerber:',
    ÜbrigeBewerber: 'Übrige Bewerber',
    ÜbrigeBewerberDoppelpunkt: 'Übrige Bewerber:',
    RemainingContigentsPerMonth: 'Restkontingente pro Monat',
    NoDataAvailable: 'Keine Daten verfügbar',
    FinalRemainingContigents: 'Letzte verbleibende Kontingente',
    Month: 'Monat',
    RemainingNumberOfApplicants: 'Verbleibende Anzahl der Bewerber',
    ÜbersichtDerBewerber: 'Übersicht der Bewerber',
    Tage: 'Tage',
    Gesamt: 'Gesamt',
    SiebenTage: '7 Tage',
    VierzehnTage: '14 Tage',
    DreißigTage: '30 Tage',
    EmailSMSAnrufe: 'Email/SMS/Anrufe',
    bisherVerschickt: 'bisher verschickt',
    maximalVerfügbar: 'maximal verfügbar',
    WorkflowsInNutzung: 'Workflows in Nutzung',
    möglicheWorkflows: 'mögliche Workflows',

    //edit-message-modal.html
    NachrichtBearbeiten: 'Nachricht bearbeiten',
    CreateNewNode: 'Neuen Knoten erstellen',
    Antwortmöglichkeiten: 'Antwortmöglichkeiten',
    Texteingabe: 'Texteingabe',
    InfoNachricht: 'Info Nachricht',
    JaNeinFrage: 'Ja/Nein Frage',
    MultiAntwort: 'Multi Antwort',
    SingleAntwort: 'Single Antwort',
    nurSpracheingabe: 'nur Spracheingabe',
    DateiHochladen: 'Datei hochladen',
    KalenderEingabe: 'Kalendereingabe',
    SingleDate: 'Einzelnes datum',
    RangeDate: 'Reichweite',
    SingleChoice: 'Single Choice',
    DieAntwortExistiertBereits: 'Die Antwort existiert bereits.',
    TerminWorkflow: 'Termin-Workflow',
    SelectATerminWorkflow: 'Wählen Sie einen Termin-Workflow',
    SetTerminWorkflow: 'Bitte wählen Sie einen Termin-Workflow aus.',
    BeingTranslated: 'Wird übersetzt...',

    //help.html
    SendenSieUnsIhreFragenKommentareUndIdeen:
      'Senden Sie uns ihre Fragen, Kommentare und Ideen',
    damitWirStetigDieMONAEngineVerbessernKönnen:
      ' damit wir stetig die MONA Engine verbessern können.',
    SupportGesprächVereinbaren: 'Support gespräch vereinbaren',
    SupportTeam: 'Support-Team',
    TelefonSupport: 'Telefon-Support:',
    EMailSupport: 'E-Mail-Support:',
    IhrName: 'Ihr Name',
    IhreEMailAdresse: 'Ihre E-Mail-Adresse',
    IhreNachricht: 'Ihre Nachricht',
    KategorieOptional: 'Kategorie (optional)',
    Stellenanzeigen: 'Stellenanzeigen',
    Kandidaten: 'Kandidaten',
    Einstellungen: 'Einstellungen',
    TypOptional: 'Typ (optional)',
    FehlerMelden: 'Fehler melden',
    FunktionVorschlagen: 'Funktion vorschlagen',
    Sonstiges: 'Sonstiges',
    IhreTelefonnummerOptional: 'Ihre Telefonnummer (optional)',
    OffeneTickets: 'Offene Tickets',
    User: 'User',
    EMail: 'E-Mail:',
    NachrichtDoppelpunkt: 'Nachricht:',

    //create-custom-video.html
    Generieren: 'Generieren',
    Text: 'Text',
    TextDeutsch: 'Text Deutsch',
    Avatar: 'Avatar',
    Sprache: 'Sprache',

    //create-howto.html
    Titel: 'Titel',
    GehörtZu: 'Gehört zu',
    Beschreibung: 'Beschreibung',
    Erklärung: 'Erklärung',
    HierErklärenWirDirWieDuEineStellenanzeigeErstellenKannst:
      'Hier erklären wir dir, wie du eine Stellenanzeige erstellen kannst.',
    UmEineStellenanzeigeZuErstellenBefolgeBitteDieFolgenenSchritteSchritt1:
      'Um eine Stellenanzeige zu erstellen, befolge bitte die folgenden Schritte. Schritt 1:...',

    //howto.html
    WillkommenBeiDenHowTos: "Willkommen bei den How-To's",
    HierFindestDuAllerleiNützlicheInformationenÜberDieMONAPlattform:
      'Hier findest du allerlei nützliche Informationen über die MONA Plattform.',
    HerzlichWillkommen: 'Herzlich Willkommen',
    NutzeGerneDieSuchfunktionObenOderKlickeDichDurchDasMenüLinksWirFreuenUnsDirHelfenZuKönnen:
      'Nutze gerne die Suchfunktion oben oder klicke dich durch das Menü links. Wir freuen uns dir helfen zu können.',
    HowToHinzufügen: 'How-To hinzufügen',
    VideoGenerieren: 'Video generieren',
    Suche: 'Suche',
    Kommunikation: 'Kommunikation',
    Teamverwaltung: 'Teamverwaltung',

    //analytics.html
    analytics: 'Analytics',

    //flowchart-graph-modal-module.html
    Fertig: 'Fertig',

    //conversations.html
    conversations: 'Conversations',

    //insights.html
    Insights: 'Insights',

    //interviews.html
    interviews: 'Interviews',

    //performance.html
    performance: 'Performance',

    //insights -> reporting.html
    Reporting: 'Reporting',
    Rahmenbedingungen: 'Rahmenbedingungen',
    Intervall: 'Intervall',
    ZeitraumWählen: 'Zeitraum wählen',
    Täglich: 'Täglich',
    Zeitraum: 'Zeitraum',
    Monatlich: 'Monatlich',
    Quartalsweise: 'Quartalsweise',
    Jährlich: 'Jährlich',
    required: '*required',
    von: 'von',
    bis: 'bis',
    Start: 'Start',
    Ende: 'Ende',
    Heute: 'Heute',
    StelleAuswählen: 'Interview auswählen',
    Kriteriumauswaehlen: 'Kriterium auswählen',
    Reset: 'Reset',
    Suchen: 'Suchen',
    KommunikationsmediumWählen: 'Kommunikationsmedium wählen',
    PhaseDesGesprächs: 'Phase des Gesprächs',
    Weiterverarbeitung: 'Weiterverarbeitung',
    Anrufe: 'Anrufe',
    EMails: 'E-Mails',
    SMS: 'SMS',
    WhatsApp: 'WhatsApp',
    Interviews: 'Interviews',
    Einstufungstests: 'Einstufungstests',
    Lebensläufe: 'Lebensläufe',
    Profile: 'Profile',
    Analysen: 'Analysen',
    NullErgebnisse: '0 Ergebnisse',
    Ergebnisse: 'Ergebnisse',
    ExportExcel: 'Export Excel',
    UnternehmenGefunden: 'Unternehmen gefunden',
    durchgeführteMatches: 'durchgeführte Matches',
    positiveMatches: 'positive Matches',
    Matches50: 'Matches >= 50%',
    negativeMatches: 'negative Matches',
    Dubletten: 'Dubletten',
    IndexUnternehmensanalyse: 'Index Unternehmensanalyse',
    Unternehmenswebsite: 'Unternehmenswebsite',
    GoogleMaps: 'Google Maps',
    KeineUnternehmenGefunden: 'Keine Unternehmen gefunden',
    SucheNachUnternehmen: 'Suche nach Unternehmen',
    POWERBI: 'POWER BI',
    ReportingTabelle: 'Reporting Tabelle',
    ExportBewerberInterviews: 'Export Bewerber & Interviews',
    Stellenanzeige: 'Stellenanzeige',
    Datum: 'Datum',
    Uhrzeit: 'Uhrzeit',
    Dauer: 'Dauer',
    Antworten: 'Antworten',
    Lebenslauf: 'Lebenslauf',
    Terminlink: 'Terminlink',
    Browser: 'Browser',
    ReportingGraph: 'Reporting Graph',
    AuswertungDerBewerberdaten: 'Auswertung der Bewerberdaten',
    ExportToPDF: 'Export to PDF',
    InterviewStreetDataAnalysis: 'Interview Street Data Analysis',
    ConversionGraph: 'Conversion Graph',
    AuswertungDerConversionRate: 'Auswertung der Conversion-Rate',
    AnzahlDatensätze: '1) Anzahl Datensätze',
    BewerberValide: '2) Bewerber valide',
    BewerberMitDokumenten: '3) Bewerber mit Dokumenten',
    BewerberMitInterview: '4) Bewerber mit Interview',
    BewerberMitTerminoption: '5) Bewerber mit Terminoption',
    BewerberMitProfilErstellt: '6) Bewerber mit Profil erstellt',
    BewerberMitProfilVersandt: '7) Bewerber mit Profil versandt',
    BewerberMitProfilMatches: '7) Suchergebnisse zu Bewerbern',
    BewerberMitProfilInteresse: '8) Bewerber mit Profil Interesse',
    BewerberMitMatches: '9) Positive Matchings',
    BewerberMitNeutralMatchings: '8) neutrale Matchings',
    geschätztesPotentialProfilvertrieb:
      '10) geschätztes Potential Profilvertrieb',
    geschätzteErfolgsquoteVermittlung:
      '11) geschätzte Erfolgsquote Vermittlung',
    geschätzteErfolgsquoteAUEV: '12) geschätzte Erfolgsquote AUEV',
    Bewerberanzahl: 'Bewerberanzahl',
    Valide: 'Valide',
    InterviewGestartet: 'Interview gestartet',
    BewerberMitProfil: 'Bewerber mit Profil',
    JobtitelUnbekannt: 'Jobtitel unbekannt',
    StandortAuswählen: 'Standort auswählen',
    Erstkontakt: 'Erstkontakt',
    Zweitkontakt: 'Zweitkontakt',
    Drittkontakt: 'Drittkontakt',
    //integrations.html
    IndeedEMailIntegration: 'Indeed E-Mail Integration',
    DieEMailIntegrationErmöglichtEsIhnenDieBewerberVonIndeedMitCVParsingFunktionInMONAEinlesenZuLassen:
      'Die E-Mail Integration ermöglicht es Ihnen die Bewerber von Indeed mit CV-Parsing Funktion in MONA einlesen zu lassen.',
    FürEineIntegrationKontaktierenSiesupportmonaaideUndWirMeldenUnsInKürze:
      'Für eine Integration, kontaktieren Sie support@mona-ai.de und wir melden uns in Kürze.',
    Indeed: 'Indeed',
    Talent360EMailIntegration: 'Talent360 E-Mail Integration',
    Talent360: 'Talent360',
    ZvooveRecruit: 'Zvoove Recruit',
    Aktivieren: 'Aktivieren',
    ZvooveBewerberAPIKey: 'Zvoove Bewerber API Key',
    ZvooveBewerberAPILink: 'Zvoove Bewerber API Link',
    ZvooveStellenAPIKey: 'Zvoove Stellen API Key',
    ZvooveStellenAPILink: 'Zvoove Stellen API Link',
    MONALoginUsername: 'MONA-Login Username',
    MONALoginPasswort: 'MONA-Login Passwort',
    KIMatching: 'KI-Matching',
    exklusiv: 'exklusiv',
    inklusiv: 'inklusiv',
    inklusivMitFallback: 'inklusiv mit Fallback',
    Zvoove: 'Zvoove',
    Aktiviert: 'Aktiviert',
    nichtAktiv: 'nicht aktiv',
    Talention: 'Talention',
    TalentionClientID: 'Talention Client-ID',
    TalentionClientSecret: 'Talention Client-Secret',
    TalentionAccountID: 'Talention Account-ID',
    TalentionIntegrationsweg: 'Talention Integrationsweg',
    Alle: 'Alle',
    GebieteNL: 'Gebiete/NL',
    Jobs: 'Jobs',
    TalentionGebieteNiederlassungen: 'Talention Gebiete & Niederlassungen',
    BeispielBerlinHamburgMünchen: 'Beispiel: Berlin,Hamburg,München',
    KeywordsMitKommaTrennen: 'Keywords mit Komma trennen*',
    CompleetAPIPersoprofilerCompana: 'Compleet API (Persoprofiler + Compana)',
    GEPEXAPI: 'GEPEX API',
    CompleetAPIKeys: 'Compleet API Keys',
    StandortAbteilung: 'Standort/Abteilung:',
    Compleet: 'Compleet',
    initiativRow: 'Fallback',
    IndexAnzeigendaten: 'Index Anzeigendaten',
    IndexLogin: 'Index Login',
    Passwort: 'Passwort',
    AlleIntegrationen: 'Alle Integrationen',
    SaaS: 'SaaS',
    OnPremise: 'On Premise',
    Ordner: 'Ordner',
    ExklusivePartnervonMONAAI: 'Exklusive Partner von ',
    AllApps: 'Alle Apps',
    Bewerberdaten: 'Bewerberdaten',
    Verlassen: 'Verlassen',
    ready: 'Bereit',
    inDevelopment: 'In Entwicklung',
    inTesting: 'In Test',
    generateApiKey: 'API Key generieren',
    DuBistEingeloggtMit: 'Du bist eingeloggt mit',
    RecruitingApi: 'Recruiting API',
    AgentApi: 'Agent API',
    Kalendar: 'Kalendar',
    Mitarbeiterdaten: 'Mitarbeiterdaten',
    Aufträge: 'Aufträge',
    allData: 'Alle Daten',
    Active: 'Aktiv',
    SearchForApps: 'Suche nach Apps',
    Erfolgreichgespeichert: 'Erfolgreich gespeichert',
    ErfolgreichgespeichertText:
      'Deine Einstellungen wurden erfolgreich gespeichert.',
    FehlertextfürdieEinstellung:
      'Deine Einstellungen konnten nicht gespeichert werden. Bitte versuche es erneut.',
    GenerateApiKey: 'API Key generieren',

    //job-offer-info.html
    zurück: 'zurück',
    Kopieren: 'Kopieren',
    StellenangebotBearbeiten: 'Stellenangebot bearbeiten',
    Stellentitel: 'Stellentitel',
    Produktionshelfer: 'z.B. Produktionshelfer (m/w/d)',
    Einleitung: 'Einleitung',
    BeschreibenSieKurzUndKnappIhrUnternehmen:
      'Beschreiben Sie kurz und knapp Ihr Unternehmen.',
    Aufgaben: 'Aufgaben',
    BeschreibenSieDieGenauenAufgabenUndVerantwortungsbereicheDerStelleDamitDerBewerberVerstehtWasDiesePositionAttraktivMacht:
      'Beschreiben Sie die genauen Aufgaben und Verantwortungsbereiche der Stelle, damit der Bewerber versteht, was diese Position attraktiv macht.',
    Qualifikation: 'Qualifikation',
    BeschreibenSieIhreAnforderungenAnDenKandidaten:
      'Beschreiben Sie Ihre Anforderungen an den Kandidaten.',
    Benefits: 'Benefits',
    NennenSieBenefitsWelcheIhrUnternehmenEinzigartigUndAttraktivMachen:
      'Nennen Sie Benefits, welche Ihr Unternehmen einzigartig und attraktiv machen.',
    Schlussworte: 'Schlussworte',
    WirFreuenUnsÜberDeineBewertung: 'z.B. Wir freuen uns über deine Bewertung!',
    GehaltBrutto: 'Gehalt (Brutto)',
    Land: 'Land',
    Stadt: 'Stadt',
    Deutschland: 'Deutschland',
    Frankreich: 'Frankreich',
    VereinigtesKönigreich: 'Vereinigtes Königreich',
    Schweiz: 'Schweiz',
    Österreich: 'Österreich',
    Belgien: 'Belgien',
    Niederlande: 'Niederlande',
    Luxemburg: 'Luxemburg',
    Spanien: 'Spanien',
    Italien: 'Italien',
    Polen: 'Polen',
    Dänemark: 'Dänemark',
    Schweden: 'Schweden',
    Norwegen: 'Norwegen',
    Finnland: 'Finnland',
    Estland: 'Estland',
    Lettland: 'Lettland',
    Litauen: 'Litauen',
    Tschechien: 'Tschechien',
    Slowakei: 'Slowakei',
    Ungarn: 'Ungarn',
    Slowenien: 'Slowenien',
    Kroatien: 'Kroatien',
    Serbien: 'Serbien',
    Ukraine: 'Ukraine',
    Russland: 'Russland',
    StadtSuchen: 'Stadt suchen',
    Vertrag: 'Vertrag',
    UploadLogo: 'Logo hochladen',
    KlickenZumÄndern: 'Klicken zum ändern',
    FarbauswahlKopfzeile: 'Farbauswahl-Kopfzeile',
    FarbauswahlKörper: 'Farbauswahl-Körper',
    FarbauswahlFürDenFirmentitel: 'Farbauswahl für den Firmentitel',
    AvatarKonfigurieren: 'Avatar konfigurieren',
    AvatarName: 'Avatar Name',
    MONA: 'z.B. MONA',
    AvatarAuswählen: 'Avatar auswählen',
    Automatisierung: 'Automatisierung',
    FragenAnDenBewerber: 'Fragen an den Bewerber',
    Parameter: 'Parameter',
    Feld: 'Feld',
    Fragetyp: 'Fragetyp',
    abfragen: 'abfragen',
    übersetztIn: 'übersetzt in',
    ParameternameExistiertBereits: 'Parametername existiert bereits.',
    NachrichtExistiertBereits: 'Nachricht existiert bereits.',
    NoMessageAnswersPresent: 'Es gibt keine Nachrichtenantworten.',
    NoCommunicationWorkflowsPresent:
      'Es sind keine Termin-Workflows festgelegt.',
    SetCommunicationWorkflowHasBeenDeleted: 'wurde gelöscht.',
    CommunicationWorkflowHasBeenDeletedExclamationOtherWorkflowExists:
      'Bitte wählen Sie einen anderen Termin-Workflow oder ändern Sie den Fragentyp.',
    ChooseAnotherQuestionTypeAsNoCommunicationWorkflow:
      'Bitte wählen Sie einen anderen Fragetyp, da kein Terminworkflow vorhanden ist.',
    InvalidMessage: 'Ungültige Nachricht',
    InterviewContainsDeletedCommunicationWorkflowMessage:
      'Das Interview enthält gelöschte Termine Workflow ',
    defaultJobOfferLanguage: 'Standardsprache für Stellenangebote',
    CodingChallenge: 'Coding Challenge',
    vorgeschlageneFragen: 'vorgeschlagene Fragen',
    ErweiterteEinstellungen: 'Erweiterte Einstellungen',
    automatischeBewerbung: 'automatische Bewerbung',
    VertragOderDokumenteErklären: 'Vertrag oder Dokumente erklären',
    Sprachsteuerung: 'Sprachsteuerung',
    CVParsingZuBeginnDesGesprächs: 'CV-Parsing',
    automatischerEinstellungstest: 'automatischer Einstellungstest',
    BrowserspracheErzwingen: 'Browsersprache erzwingen',
    Feedback: 'Feedback vom Bewerber',
    SprachenAuswählen: 'Sprachen auswählen',
    deutsch: 'deutsch',
    französisch: 'französisch',
    bulgarisch: 'bulgarisch',
    englisch: 'englisch',
    ukrainisch: 'ukrainisch',
    türkisch: 'türkisch',
    rumänisch: 'rumänisch',
    polnisch: 'polnisch',
    slowakisch: 'slowakisch',
    arabisch: 'arabisch',
    ungarisch: 'ungarisch',
    tschechisch: 'tschechisch',
    portugiesisch: 'portugiesisch',
    italienisch: 'italienisch',
    holländisch: 'holländisch',
    spanisch: 'spanisch',
    russisch: 'russisch',
    dänisch: 'dänisch',
    schwedisch: 'schwedisch',
    chinesisch: 'chinesisch',
    kroatisch: 'kroatisch',
    serbisch: 'serbisch',
    albanisch: 'albanisch',
    kasachisch: 'kasachisch',
    indonesisch: 'indonesisch',
    litauisch: 'litauisch',
    estnisch: 'estnisch',
    afrikaans: 'afrikaans',
    hindi: 'hindi',
    malayalam: 'malayalam',
    Flowchart: 'Flowchart',
    ConditionalRoutings: 'Conditional Routings',
    FlowchartZurücksetzen: 'Flowchart zurücksetzen',
    CreateANewNodeButton: 'Erstellen Sie einen neuen Knoten',
    backToJobOffersHeader: 'Zurück zur Stellenübersicht',
    fontStyleLabel: 'Schriftart auswählen',
    backToJobOffersMessage:
      'Möchtest du wirklich zurück zu den Stellenanzeigen?',
    FlowchartZurücksetzenText:
      'Möchtest du den Flowchart wirklich zurücksetzen?',
    IframeKopieren: 'iFrame Kopieren',
    addJobButtonText: 'Interview Erstellen',
    FullscreenFlowchart: 'Vollbildmodus aktivieren',
    ExportToExcel: 'Export als Excel',
    EinstellungstestAnAlleSenden: 'Einstellungstest an alle senden',
    Herkunft: 'Herkunft',
    Bewerbernummer: 'Bewerbernummer',
    Stelle: 'Stelle',
    Email: 'Email',
    Telefon: 'Telefon',
    Bewerbungseingang: 'Bewerbungseingang',
    QALab: 'Q&A Lab',
    LimitReached: 'Limit erreicht',
    LimitReachedMessage: 'Sie haben das maximale Limit erreicht',
    MessageStillInFlowchart:
      'Diese Nachricht ist noch im Flowchart. Bitte entfernen Sie sie zuerst aus dem Flowchart, bevor Sie sie hier deaktivieren.',
    //new-job-offer.html
    SpeichernAlsTemplate: 'Als Template Speichern',
    StellenangebotErstellen: 'Stellenangebot erstellen',
    HINWEIS: 'Hinweis',
    SAVE_AS_DRAFT: 'Als Entwurf speichern',
    SAVE_IN_TEST_MODE: 'im Testmodus speichern',
    InfoMessageForMessagePresentInFlowhchart:
      'Bitte löschen Sie zunächst die Nachricht aus dem Flussdiagramm.',
    ToastForStandaloneNodes:
      'Jeder Knoten muss über mindestens einen eingehenden Link und einen ausgehenden Link verfügen, mit Ausnahme des Knotens Start- und Endsitzung.',
    ToastStandaloneNodeAdded:
      'Ein eigenständiger Knoten wurde hinzugefügt. Bitte stellen Sie eine Verbindung mit einem Quell- und einem Zielknoten her, um daraus ein gültiges Flussdiagramm zu erstellen.',
    ToastHeaderForStandaloneNodes:
      'Flussdiagramm enthält eigenständigen Knoten',
    CVUPLOAD_FLOWCHART_NODE_EXISTS_TOAST:
      'CV-Upload-Knoten existiert in einem Flussdiagramm. Bitte entfernen Sie ihn aus dem Flussdiagramm, um ihn zu deaktivieren.',
    INVALID_ANSWER_IN_FLOWCHART_LINK: 'Ungültige Antwort im Flowchart-Link',
    INVALID_ANSWER_IN_FLOWCHART_LINK_MESSAGE:
      'Bitte überprüfen Sie das Flussdiagramm. Es gibt einen Link mit einer ungültigen Antwort. Bitte korrigieren Sie ihn, um das Stellenangebot zu speichern.',
    MESSAGE_MULTIPLE_LINKS_FROM_ONE_NODE_WITH_SAME_CONDITION_IS_NOT_ALLOWED:
      'Mehrere Links mit derselben Bedingung sind nicht erlaubt.',

    //qna-lab.html
    VorgeschlageneFragen: 'Vorgeschlagene Fragen',
    Aktualisieren: 'Aktualisieren',
    StellenanzeigeBearbeiten: 'Stellenanzeige bearbeiten',
    GenerierenSieFragen: 'Generieren Sie Fragen',
    Hinzufügen: 'Hinzufügen',
    AILabTrainingPanel: 'AI Lab Training Panel',
    Keyword: 'Keyword',
    Anzahl: 'Anzahl',
    Keywords: 'Keywords',
    Deutsch: 'deutsch',
    //profile.html
    CoreDataAccess: 'Core Data Access',
    AgentManagement: 'Agent Management',
    ToolManagement: 'Tool Management',
    MatchingAnalytics: 'Matching & Analytics',
    DocumentProcessing: 'Document Processing',
    Communication: 'Communication',
    Administrative: 'Administrative',

    ExecuteAgents: 'Execute Agents',
    ExecuteWorkflow: 'Execute Workflow',
    ReadTools: 'Read Tools',
    ManageTools: 'Manage Tools',
    ReadMatching: 'Read Matching',
    CreateMatching: 'Create Matching',
    ReadAnalytics: 'Read Analytics',
    Parsing: 'Parsing',
    ReadCommunication: 'Read Communication',
    ManageApiKeys: 'Manage API Keys',
    SystemAdmin: 'System Admin',
    AccountEinstellungen: 'Account Einstellungen',
    UnternehmensInformationen: 'Unternehmens Informationen',
    WebseitenLink: 'Webseiten Link',
    Farbauswahl: 'Farbauswahl',
    FarbeAuswählen: 'Farbe auswählen',
    SpracheAuswählen: 'Sprache auswählen',
    Kontaktierung: 'Kontaktierung',
    Standorte: 'Standorte',
    Straße: 'Straße',
    Hausnr: 'Hausnr',
    PLZ: 'PLZ',
    Ort: 'Ort',
    id: 'ID',
    EMinusMail: 'E-Mail',
    calendlyLink: 'Calendly Link',
    Datenschutz: 'Datenschutz',
    GebenSieHierIhrenDatenschutzLinkEin:
      'Geben Sie hier Ihren Datenschutz-Link ein',
    MatchingProfilvertrieb: 'Matching & Profilvertrieb',
    FallbackFürInterviews: 'Fallback für Interviews',
    FallbackFürFinishedInterviewDocument:
      'Fallback für Finished Interview Document',
    MatchingExtern: 'Matching extern',
    MinimumMatchingErgebnis: 'Minimum Matching Ergebnis',
    MatchingKriterium: 'Matching Kriterium',
    MatchingTyp: 'Matching Typ',
    MatchingGewicht: 'Matching Gewicht',
    Optionen: 'Optionen',
    EUWorker:
      'EU-Worker - lebt in EU, soll vermittelt werden nach DE. Lebensstandort des Bewerbers wird nicht für Matching verwendet wenn aktiv. Gilt nicht für Personen, die in Deutschland leben.',
    Hard: 'Hard',
    Soft: 'Soft',
    ausgewähltIstDannMussDasKriteriumErfülltWerdenDamitEinMatchVorliegt:
      'ausgewählt ist, dann muss das Kriterium erfüllt werden, damit ein Match vorliegt.',
    ausgewähltIstDannMussDasKriteriumNichtErfülltWerdenDamitEinMatchVorliegt:
      'ausgewählt ist, dann muss das Kriterium nicht erfüllt werden, damit ein Match vorliegt.',
    EineGewichtungVon1IstDieNiedrigsteGewichtungFürEinMatchingkriterium:
      'Eine Gewichtung von 1 ist die niedrigste Gewichtung für ein Matchingkriterium.',
    EineGewichtungVon200IstDieNiedrigsteGewichtungFürEinMatchingkriterium:
      'Eine Gewichtung von 200 ist die niedrigste Gewichtung für ein Matchingkriterium.',
    insgesamtKönnen20KriterienAngepasstWerdenGematchedWerdenInsgesamt25KriterienUndDieInterviewergebnisse:
      'Insgesamt können 20 Kriterien angepasst werden. Gematched werden insgesamt 25 Kriterien und die Interviewergebnisse',
    BewerberprofilKonfigurieren: 'Bewerberprofil konfigurieren',
    ProfilbildAutomatischErgänzen: 'Profilbild automatisch ergänzen',
    SprachenMüssenEnthaltenSein: 'Sprachen müssen enthalten sein',
    BerufserfahrungMussEnthaltenSein: 'Berufserfahrung muss enthalten sein',
    AtLeastThreeJobs: 'mindestens drei Berufspositionen',
    WennDerMatchingTyp: 'Wenn der Matching-Typ',
    Zertifikate: 'Zertifikate',
    Softskills: 'Softskills',
    ProjektkenntnisseMüssenEnthaltenSein:
      'Projektkenntnisse müssen enthalten sein',
    AufenthaltserlaubnisArbeitserlaubnisMussVorliegenOderAbgefragtSein:
      'Aufenthaltserlaubnis/Arbeitserlaubnis muss vorliegen oder abgefragt sein',
    ExternalAccess: 'Externer Zugang',
    ExternalAccessSettings: 'Externe Zugriffseinstellungen',
    ExternalAccessSettingsMessage:
      'Erlauben Sie externen Integrationen, Daten für Ihre Bewerber, Jobangebote und Agenten zu pushen/zu holen.',
    ReadApplicants: 'Bewerber lesen',
    PushApplicants: 'Bewerber pushen',
    ReadJobOffers: 'Stellenangebote lesen',
    PushJobOffers: 'Stellenangebote pushen',
    ReadAgents: 'Agenten lesen',
    PushAgents: 'Agenten pushen',
    ReadData: 'Daten lesen',
    PushData: 'Daten pushen',
    GenerateAPIKey: 'API-Schlüssel Generieren',
    YourNewAPIKey: 'Ihr neuer API-Schlüssel',
    PleaseCopyThisKeyMessage:
      'Bitte kopieren Sie diesen Schlüssel jetzt. Sie werden ihn später nicht mehr sehen können.',
    EmailAutomation: 'E-Mail-Automatisierung',
    EmailAutomationSettings: 'E-Mail-Automatisierungseinstellungen',
    EmailAutomationSettingsMessage:
      'Generieren Sie eine neue E-Mail-Adresse und verbinden Sie sie mit einem Workflow, der ausgelöst wird, wenn eine E-Mail eingeht.',
    SaveEmailConfigurationManually: 'E-Mail-Konfiguration manuell speichern',
    GenerateNewEmailAddress: 'Neue E-Mail-Adresse Generieren',
    DeleteEmailAccount: 'E-Mail-Konto Löschen',
    IMAPEmailAddress: 'IMAP E-Mail Adresse',
    SMTPEmailAddress: 'SMTP E-Mail Adresse',
    ExternalAccessAndAPI: 'Externer Zugang & API',
    AboAndSubscription: 'Abo & Abonnement',
    UserId: 'Benutzer-ID',
    SelectUser: 'Benutzer Auswählen',
    SelectRole: 'Rolle Auswählen',
    Recruiter: 'Anwerber',
    Admin: 'Verwaltung',
    ManageBillingSettingsHere:
      'Verwalten Sie Ihre Rechnungseinstellungen hier.',
    MatchingTypeForMonaJobs: 'Matching-Typ für MONA Jobs',
    MatchingArtMONA: 'Matching-Art für MONA-Stellen',
    YourNewEmailAddress: 'Ihre neue E-Mail Adresse',
    SelectWorkflow: 'Workflow Auswählen',
    PleaseCopyThisPasswordMessage:
      'Bitte kopieren Sie dieses Passwort jetzt, wenn Sie es für andere APIs benötigen. Sie werden es später nicht mehr sehen können.',
    SavePermissions: 'Berechtigungen Speichern',
    ManageBilling: 'Abrechnungen Verwalten',
    AIAssistant: 'KI-Assistent',
    SaveAutomation: 'Automatisierung Speichern',
    Bewerberstatus: 'Bewerberstatus',
    Bewerberquelle: 'Bewerberquelle',
    Job_Bezeichnung: 'Job Bezeichnung',
    Verfügbarkeit: 'Verfügbarkeit',
    Gehalt: 'Gehalt',
    Arbeitszeit: 'Arbeitszeit',
    Arbeitsvertrag: 'Arbeitsvertrag',
    Branchenkenntnisse: 'Branchenkenntnisse',
    projectExperience: 'Projekt Erfahrung',
    Persönlichkeit: 'Persönlichkeit',
    Arbeitsrechtliche_Einschränkungen: 'Arbeitsrechtliche Einschränkungen',
    Management_Level: 'Management Level',
    Mobilität: 'Mobilität',
    DeleteEmailAccountMessage:
      'Sind Sie sicher, dass Sie dieses E-Mail-Konto löschen möchten?',
    password: 'Passwort',
    EmailAccountDeleted: 'E-Mail-Konto erfolgreich gelöscht',
    EmailAccountSaved: 'E-Mail-Konto erfolgreich gespeichert',
    AIAssistantMessage:
      'Funktionalitäten für Ihre Benutzer zulassen oder verbieten',
    ErstkontaktInsights: '11) Erstkontakt',
    ZweitkontaktInsights: '12) Zweitkontakt',
    DrittkontaktInsights: '13) Drittkontakt',

    // mona-agent-chat.page.html
    sendSMS: 'SMS senden',
    sendMail: 'E-Mail senden',
    sendCall: 'Anruf senden',
    sendWhatsApp: 'WhatsApp senden',
    sendLinkedIn: 'LinkedIn senden',
    sendXing: 'Xing senden',
    sendFacebook: 'Facebook senden',
    sendInstagram: 'Instagram senden',
    sendX: 'X senden',
    confirm: 'Bestätigen',
    FreigegebeneTelefonnummern: 'Freigegebene Telefonnummern',
    Landauswählen: 'Land auswählen',
    VollständigeNummer: 'Vollständige Nummer',
    FreigegebeneEMailAdressen: 'Freigegebene E-Mail-Adressen',
    Sprachpräferenzen: 'Sprachpräferenzen',
    Bestätigen: 'Bestätigen',

    //delete-job-offer.html
    StellenanzeigeLöschen: 'Stellenanzeige löschen',
    SindSieSicherDassSieDieseStellenanzeigeLöschenMöchten:
      'Sind Sie sicher, dass Sie diese Stellenanzeige löschen möchten?',

    //job-offers.html
    NeuLaden: 'Neu Laden',
    Aktiv: 'Aktiv',
    Draft: 'Vorlagen',
    Test: 'Test',
    Gelöscht: 'Gelöscht',
    ImportierenVonStellenanzeigen: 'Importieren von Stellenanzeigen',
    ExportierenVonStellenanzeigen: 'Exportieren von Stellenanzeigen',
    Reaktivieren: 'Reaktivieren',
    Verträge: 'Verträge',
    Aktualisiert: 'Aktualisiert',
    Stellenangebot: 'Stellenangebot',
    Standort: 'Standort',
    URL: 'URL',
    Iframe: 'Iframe',
    StatusDerBereitstellung: 'Status der Bereitstellung',

    //logo.html
    ChangeCompanyLogoJPGPNG: 'Logo ändern (JPG/PNG)',
    BildHinzufügen: 'Bild hinzufügen',
    BitteGebenSieEinKleineresBildEin:
      'Bitte laden Sie ein kleineres Bild hoch.',
    Entfernen: 'Entfernen',

    //message -> configure-message.html
    AlteNachricht: 'Alte Nachricht',
    NeueNachricht: 'Neue Nachricht',
    neueNachrichtEingeben: 'neue Nachricht eingeben',

    //mona-communication-list.html
    Recruiting: 'Recruiting',
    Onboarding: 'Onboarding',
    Vertrieb: 'Vertrieb',
    VertriebHistorie: 'Vertrieb-Historie',
    WorkflowsAnwenden: 'Workflows anwenden',
    RunAgentTask: 'Run Agent Task',
    SalesmailsLöschen: 'Salesmails löschen',
    SalesmailsFreigeben: 'Salesmails freigeben',
    Ziel: 'Ziel',
    Dokumente: 'Dokumente',
    BewerberId: 'Bewerber ID',
    Kontakt: 'Kontakt',
    EmailPreview: 'Email Vorschau',
    ViewEmail: 'Email anzeigen',
    Company: 'Firma',
    Location: 'Standort',
    Position: 'Position',
    URLLink: 'URL Link',
    CompanyLink: 'Firmenlink',
    CompanyReport: 'Firmenreport',
    CompanyPhone: 'Firmen Telefon',
    ContactPerson: 'Kontaktperson',
    ContactPersonEmail: 'Kontaktperson Email',
    ContactPersonPhone: 'Kontaktperson Telefon',
    Goal: 'Ziel',
    AcquisitionSubject: 'Akquise Betreff',
    MatchingPunktzahl: 'Matching Punktzahl',
    Erklaerung: 'Erklärung',
    Reflexion: 'Reflexion',
    Unternehmensdetails: 'Unternehmensdetails',
    OpenDocument: 'Dokument öffnen',
    EditEmail: 'E-Mail bearbeiten',
    ViewEmailContent: 'E-Mail-Inhalt anzeigen',
    AttachNewAttachment: 'Neuen Anhang hinzufügen',
    ShowLead: 'Lead anzeigen',
    ShowCompanyDetails: 'Unternehmensdetails anzeigen',
    ShowMoreJobs: 'Mehr Jobs anzeigen',
    Cancel: 'Abbrechen',
    Versanddatum: 'Versanddatum',
    SpaltenAnpassen: 'Spalten anpassen',
    Notes: 'Notizen',
    SetValueOfDeal: 'Wert des Profils festlegen',
    //team-management.html
    Team: 'Team',
    TeammitgliederVerwalten: 'Teammitglieder verwalten',
    Einladen: 'Einladen',

    //news.html
    UpdateLOG: 'Update - LOG',
    TageHer: 'Tage her',
    Plattform: 'Plattform',
    Verbesserung: 'Verbesserung',
    BugFix: 'Bug-Fix',

    //preview-file.html
    Herunterladen: 'Herunterladen',
    abgeschlossenesStudium: 'abgeschlossenes Studium',
    mehrAls6MonateBerufserfahrung: 'mehr als 6 Monate Berufserfahrung',
    Deutschkenntnisse: 'Deutschkenntnisse',
    Übernehmen: 'Übernehmen',
    FehlerBeimLadenDerDatei: 'Fehler beim Laden der Datei...',
    AnswerVideo: 'Antwort Video',
    Image: 'Bild',
    MatchingErgebnisseZusenden: 'Sales Mails-Liste zusenden per Mail',

    //applicant-create-short-info.html
    BewerberAnlegen: 'Bewerber anlegen',
    BewerberSchnellerfassung: 'Bewerber-Schnellerfassung',
    Strasse: 'Straße',
    Hausnummer: 'Hausnummer',
    Wohnort: 'Wohnort',
    TelefonMobil: 'Telefon / Mobil',
    Geburtsdatum: 'Geburtsdatum',
    ChoosePDFFile: 'PDF-Datei wählen',
    //constants.ts
    PERSONALIZE_MESSAGE:
      'Diese standardmäßige personalisierte Nachricht würde angezeigt, wenn Sie keine personalisierte Nachricht festlegen. Wir möchten Sie daher bitten, Ihre eigene personalisierte Nachricht festzulegen und auf die Schaltfläche „Speichern“ zu klicken.',
    GENERATEQAQUESTIONS_LOADING_MESSAGE:
      'Bitte warten Sie 15 Sekunden, während wir Fragen generieren.',
    GENERATEQA_PROMPT_MESSAGE:
      'Listen Sie die 10 wichtigsten Fragen auf, die Sie einem Personalvermittler als Bewerber für die Stelle stellen sollten ',
    JOB_TITLE_NOTSET_MESSAGE:
      'Um vorgeschlagene Fragen zu generieren, geben Sie bitte hier den Stellentitel ein.',
    REFRASEQANDAQUESTIONS_TEXTBLOCK:
      'Nachfolgend sende ich dir mit Komma seperierte Fragen. Formuliere jede Fragen in 10 verschiedenen weisen um. Formuliere sie so, als würde sie ein Bewerber an einen Recruiter stellen. Gebe mir das Ergebnis als valides Json format zurück mit den von mir gesendeten Fragen als Key und den von dir umgewandelten Fragen als value. Das json objekt soll wie folgt aufgebaut werden. {"frage1": [""]}. Lösche alles, was verhindert, dass es ein valides JSON objekt wird. Ersetze \'frage\' mit den Fragen, die ich dir gebe und den Array \'[""]\' mit den Ergebnissen von dir. Gib mir keine weiteren Erklärungen: ',
    AIALERT_MESSAGE:
      'Das KI-Modell wird jetzt trainiert. Dies dauert ca. 10 Minuten. Anschließend kann das Gespräch geführt werden.',
    AIFEEDBACKONPREQUISITES_MESSAGE:
      'Nachfolgend ist der Text für eine Stellenanzeige. Welche Fragen würdest du an einen Bewerber stellen, um herauszufinden, ob er die Anforderungen an die Stellenanzeige erfüllt? Formuliere maximal 10 Fragen: ',
    VALIDATE_CANTLINKTOITSELF_MESSAGE:
      'Du kannst keinen Knoten auf sich selbst verlinken',
    VALIDATE_NOCONDITIONSBUTVALUEISSET_MESSAGE:
      'Sie können keinen Knoten mit Wert, aber ohne Bedingung verknüpfen',
    VALIDATE_CONDITIONPRESENTBUTVALUEISNOTSET_MESSAGE:
      'Kann keinen Link ohne Wert hinzufügen und ',
    VALIDATE_NOCONDITIONS_ONSTARTNODE_MESSAGE:
      'Zum Startknoten können keine Bedingungen hinzugefügt werden',
    VALIDATE_NEWUPDATEDLINK_CONTAINSVALUEBUTCONDITIONJAORNEIN_MESSAGE:
      "Link mit dem Wert 'true' oder 'false', aber mit der Bedingung 'Yes' oder 'No' ist ungültig.",
    MAXIMUM_QUESTIONS_REACHED_MESSAGE: 'Maximale Anzahl von Fragen erreicht',
    VALIDATECYCLE_WITHOUTCONDITIONS_MESSAGE:
      'Zyklen oder Mehrfachverknüpfungen ohne Bedingungen sind nicht zulässig',
    ERROR_CLOUDFUNCTION_MESSAGE:
      'Fehler beim Aufrufen der Google Cloud Function: ',
    //   GENERATE_ASSESSMENT_ANSWERS:  "Bitte generieren Sie 4 Multiple-Choice-Optionen für die folgende Frage. Von den Optionen müssen 3 falsch und 1 richtig sein. Bitte geben Sie die Antwort als JSON-Objekt zurück, bestehend aus der Frage als „frage“, 4 Optionen als „optionen“ und der richtigen Antwort als „richtig“. Schreiben Sie Optionen im JSON als [„Option 1“, „Option 2“, „Option 3“, „Option 4“]",
    GENERATE_ASSESSMENT_ANSWERS:
      '„Bitte generieren Sie 4 Multiple-Choice-Optionen für die folgende Frage. Von den Optionen müssen 3 falsch und 1 richtig sein. Bitte geben Sie die Antwort als JSON-Objekt zurück, bestehend aus der Frage als „Frage“, 3 falschen Optionen als „falsch“ und der richtigen Antwort als „richtig“. Schreiben Sie die falschen Optionen in JSON als [„Option 1“, „Option 2“, „Option 3“]“; Hier ist die Frage:',
    //   GENERATE_ASSESSMENT_QUESTIONS_ANSWERS_ONLY_TITLE: "Lesen Sie den Titel und stellen Sie genau 10 nicht ganz einfache Fragen. Für diese 10 Fragen sollte es 4 Optionen geben, von denen 3 falsch und 1 richtig sein sollten. Geben Sie es als einfaches JSON-Objektformat zurück. Befolgen Sie strikt diese Beispielvorlage: {frage: \"example questions\", optionen: [\"option 1\", \"option 2\", \"option 3\", \"option 4\"], richtig: \"option 3\"}. Hier ist der Titel der Rezension:",
    //   GENERATE_ASSESSMENT_QUESTIONS_ANSWERS_ONLY_TITLE: "Lesen Sie den Titel und stellen Sie genau 10 nicht ganz einfache Fragen. Für diese 10 Fragen sollte es 4 Optionen geben, von denen 3 falsch und 1 richtig sein sollten. Geben Sie es als einfaches Array im JSON-Objektformat zurück. Befolgen Sie strikt diese Beispielvorlage: [{„frage“: „Beispielfragen“, „optionen“: [„Option 1“, „Option 2“, „Option 3“, „Option 4“], „richtig“: „Option 3“}, {„frage“: „Beispielfragen“, „optionen“: [„Option 1“, „Option 2“, „Option 3“, „Option 4“], „richtig“: „Option 3“}]. Hier der Titel der Rezension:",
    GENERATE_ASSESSMENT_QUESTIONS_ANSWERS_ONLY_TITLE:
      'Lesen Sie den Titel und stellen Sie genau 10 nicht ganz einfache Fragen. Für diese 10 Fragen sollte es 4 Optionen geben, von denen 3 falsch und 1 richtig sein sollten. Geben Sie es als einfaches Array im JSON-Objektformat zurück. Halten Sie sich strikt an diese Beispielvorlage: [{„frage“: „Beispielfragen“, „falsch“: [„Option 1“, „Option 2“, „Option 3“], „richtig“: „Option 4“ }, {„frage“: „Beispielfragen“, „falsch“: [„Option 1“, „Option 2“, „Option 3“], „richtig“: „Option 4“}]. Hier der Titel der Rezension:',
    PREVIEW_NOT_AVAILABLE_HEADER: 'Vorschau nicht verfügbar',
    PREVIEW_NOT_AVAILABLE_MESSAGE:
      'Ihre Datei wurde hochgeladen, kann jedoch nicht in der Vorschau angezeigt werden.',
    DATA_PROTECTION_URL_INVALID_MESSAGE:
      'Die Datenschutz-URL ist ungültig. Bitte geben Sie eine gültige URL ein und versuchen Sie es erneut.',
    DATA_PROTECTION_URL_NOTE_MESSAGE: 'Bitte geben Sie eine gültige URL ein.',
    JOB_OFFER_RESTORED: 'Stellenangebot wurde reaktiviert',
    NO_JOB_OFFER_RECORDS_TEXT: 'Keine Stellenangebote gefunden',
    NO_APPLICANT_RECORDS_TEXT: 'Keine Bewerber gefunden',
    APPLICANT_DELETED_SUCCESSFULLY: 'Bewerber erfolgreich gelöscht',
    LOADING_TEXT_DASHBOARD: 'Wird geladen...',
    STELLENANZEIGE_ERSTELLEN: 'Interview erstellen',
    IFRAME_KOPIEREN: 'IFrame kopieren',
    EMAIL_TEXT:
      'Hey $firstname $lastname,\n\ndu hast dich erfolgreich bei der Firma $companyname beworben.\n\nKlicke auf den untenstehenden Link, um dein Interview mit unserer digitalen Mitarbeiterin zu starten.\n\n$interactionURL',
    SMS_TEXT:
      'Hey $firstname $lastname,\n\ndu hast dich erfolgreich bei der Firma $companyname beworben.\n\nKlicke auf den untenstehenden Link, um dein Interview mit unserer digitalen Mitarbeiterin zu starten.\n\n$interactionURL',
    BETREFF_TEXT: 'Starte jetzt dein Interview',
    CALENDLY_BETREFF_TEXT: 'Buche dir jetzt deinen Kennenlern-Termin',
    CALENDLY_TEXT:
      'du hast dich erfolgreich für den Job bei $companyname beworben.\n\nAnbei erhälst du einen Link um dir einen Kennenlern-Termin zu buchen.\n\n',

    STATUS_INPRÜFUNG: 'in Prüfung',
    STATUS_INTERVIEW_ABGESCHLOSSEN: 'Interview abgeschlossen',
    STATUS_BEGINNT_BEWERBUNGSPROZESS: 'beginnt Bewerbungsprozess',
    STATUS_EINGESTELLT: 'Eingestellt',
    STATUS_VERMITTELT: 'Vermittelt',
    STATUS_ABSAGE_DURCH_DISPONENT: 'Absage durch Disponent',
    STATUS_ABSAGE_DURCH_KUNDE: 'Absage durch Kunde',
    STATUS_ABSAGE_DURCH_BEWERBER: 'Absage durch Bewerber',
    STATUS_EINLADUNG_ZUM_VG: 'Einladung zum VG',
    STATUS_NOCHMAL_ANRUFEN: 'nochmal anrufen',
    STATUS_PROBEARBEIT: 'Probearbeit',
    STATUS_PROFIL_AN_KUNDEN: 'Profil an Kunden weitergeleitet',
    STATUS_RÜCKRUF_FÜR_VEREINBARUNG: 'Rückruf für Vereinbarung VC/Interview',
    STATUS_VC_INTERVIEW_NICHT_WAHRGENOMMEN: 'VC/Interview nicht wahrgenommen',
    STATUS_VC_INTERVIEW_VEREINBART: 'VC/Interview vereinbart',
    STATUS_VG_DURCHGEFÜHRT: 'VG durchgeführt',
    STATUS_VG_NICHT_ERSCHIENEN: 'VG nicht erschienen',
    STATUS_BEFINDET_SICH_AKTUELL_IM_INTERVIEW:
      'befindet sich aktuell im Interview',
    STATUS_EINSTELLUNGSTEST_ABGESCHLOSSEN: 'Einstellungstest abgeschlossen',
    SPECIFY_NODES:
      'Du musst mindestens einen Knoten im Flowchart zwischen dem Start Knoten und dem End Knoten angeben.',
    SPECIFY_END_NODES:
      'Du musst einen End Session Knoten im Flowchart angeben.',
    INVALID_FLOWCHART: 'Ungültiger Flowchart',
    IS_DANKE_MESSAGE_SAVED:
      'Bitte speichern Sie die "Danke" Nachricht im Tab "Automatisierung"',
    IS_SPRACHE_MESSAGE_SAVED:
      'Bitte speichern Sie die "Sprache" Nachricht im Tab "Automatisierung"',
    IS_CVUpload_MESSAGE_SAVED:
      'Bitte speichern Sie die "CV Upload" Nachricht im Tab "Automatisierung"',
    STELLENANZEIGE_ERSTELLEN_MESSAGE:
      'Deine Änderungen in den Fragen konnten im Flowchart nicht übernommen werden. Bitte überprüfe den Flowchart.',
    ADD_END_SESSION_NODE_MESSAGE:
      'Füge ein End Session Node im Flowchart hinzu!',
    DELETE_MESSAGE: 'Möchten Sie wirklich die Nachricht löschen: ',
    NEED_TO_ADD_END_SESSION: 'Add an end session node to your workflow',
    ERROR_WHEN_OPEN_APPLICANT: 'Fehler beim Öffnen des Bewerbers',
    UPDATE_JOB_ADVERTISEMENT: 'Stellenanzeige aktualisieren',
    PUBLISH: 'Veröffentlichen',
    ASK_QUESTIONS_PROMT:
      'Hast du noch Fragen an mich? Du kannst die Fragen jetzt stellen. Nutze dazu das Textfeld oder die Spracheingabe.',
    JOB_AD_TEXT:
      'Unten ist der Text für eine Stellenausschreibung. Welche Fragen würden Sie einem Bewerber stellen, um festzustellen, ob er die Anforderungen für die Stellenausschreibung erfüllt? Formulieren Sie maximal 10 Fragen und geben Sie an, ob es sich um eine Ja-, Nein- oder Eingabefeldfrage handelt: ',
    CLICK_TO_SEE_IMAGE: 'Bild ansehen',
    MESSAGE_AFTER_EDIT_QUESTION_TYPE:
      'Sie haben den Fragetyp geändert. Bitte überprüfen Sie das Flussdiagramm.',
    CANT_DELETE_LAST_LINK:
      'Sie können den letzten Link nicht löschen. Das Flussdiagramm muss mindestens einen Link enthalten.',
    FLOWCHART_START_NODE_MULTIPLE_EDGES:
      'Flussdiagramm mit mehreren Links vom Startknoten ist kein gültiges Flussdiagramm.',
    // flowchart.ts
    selectLocation: 'Standort auswählen',
    Handynummer: 'Handynummer',
    Abschicken: 'Abschicken',
    DELETE_FLOWCHART: 'Flowchart wirklich löschen?',
    EXISTIERT_BEREITS: 'existiert bereits',
    KNOTEN_HINZUFUGEN: 'Knoten hinzufügen',
    VERBINDUNG_AKTUALISIEREN: 'Verbindung aktualisieren',
    LINK_UPDATE_WITH_INVALID_ANSWER:
      'Linkaktualisierung mit ungültiger Nachrichtenantwort ist nicht erlaubt.',
    MESSAGE_MULTIPLE_LINKS_WITH_SAME_VALUE_AND_SAME_CONDITION:
      'Mehrere Links von demselben Knoten mit identischer Antwort und Bedingung sind ungültig.',
    REACTIVATING_JOB_OFFER_CONTAINS_DELETED_WORKFLOW:
      'Die Reaktivierung der Stellenausschreibung enthält einen gelöschten Workflow. Bitte korrigieren Sie den Workflow und versuchen Sie es erneut.',

    ReloadAutoSaveData:
      'Möchten Sie die automatisch gespeicherten Daten laden?',
    MessageExist: 'Die Nachricht existiert bereits',
    MessageExistInfo:
      'Die Nachricht existiert bereits im Flowchart. Bitte löschen Sie sie und erstellen Sie sie erneut.',
    MessageNotExist: 'Die Nachricht existiert nicht',
    MessageNotExistInfo: 'Die Nachricht wurde den Fragen nicht hinzugefügt.',
    CanNotConnect: 'kann nicht mit einer Condition verbunden werden',
    MustHaveCondition: 'muss eine Condition haben',
    ConditionNotWithYesNoMessage:
      'Condition kann nicht mit Ja/Nein-Nachricht verbunden werden',
    ConditionNotWithSingleMultiMessage:
      'Condition kann nicht mit Einzelauswahl/Mehrfachauswahl oder Dokument-Upload-Nachricht verbunden werden',
    ConditionWithValue: 'Condition mit dem Wert',
    DoesNotExistInMessage: 'existiert nicht in der Nachricht',
    ConditionWithYesNoMessage:
      'Condition kann nur mit Ja/Nein-Nachricht verbunden werden',
    ConditionWithSingleMultiMessage:
      'Condition kann nur mit Einzelauswahl/Mehrfachauswahl oder Dokument-Upload-Nachricht verbunden werden',
    ConditionNotWithStart:
      'Condition kann nicht mit Start-Nachricht verbunden werden',
    SourceOfConditionNotExist: 'Quelle der Condition existiert nicht',
    ConditionOneMessage:
      'Condition kann nur mit einer Nachricht verbunden werden',
    doesNotExist: 'existiert nicht',
    HasAnotherSource: 'hat eine andere Quelle',
    HasAlreadyCondition: 'hat bereits eine Condition',
    HasConnectWithCurrentCondition:
      'ist bereits mit der aktuellen Condition verbunden',
    CanNotConnectYesNoCondition:
      'kann nicht mit Ja- oder Nein-Condition verbunden werden',
    NotYesNoMessage: 'ist keine Ja/Nein-Nachricht',
    NotSingleMultiMessage:
      'ist keine Einzelauswahl/Mehrfachauswahl oder Dokument-Upload-Nachricht',
    ConditionWithOtherTarget:
      'Condition wurde bereits mit einem anderen Ziel verbunden',
    ActionWithOtherTarget:
      'Aktion wurde bereits mit einem anderen Ziel verbunden',
    StartNotAsTarget: 'Start-Nachricht kann nicht als Ziel verbunden werden',
    EndNotAsSource:
      'Sitzungsende-Nachricht kann nicht als Quelle verbunden werden',
    NotLoop:
      'Es konnte keine Verbindungsschleife zwischen zwei Nachrichten erstellt werden',
    MessageWithOtherTarget:
      'Nachricht wurde bereits mit einem anderen Ziel verbunden',
    ConditionNotWithCondition:
      'Condition kann nicht mit einer anderen Condition verbunden werden',
    ActionConditiontarget:
      'Aktion kann nicht mit einer Condition als Ziel verbunden werden',
    ActionNotWithAction:
      'Aktion kann nicht mit einer anderen Aktion als Ziel verbunden werden',
    ConditionBetweenMessageCondition:
      'Condition kann nicht zwischen Nachricht und Condition verbunden werden',
    ActionBetweenMessageCondition:
      'Aktion kann nicht zwischen Nachricht und Condition verbunden werden',
    ActionBetweenMessageAction:
      'Aktion kann nicht zwischen Nachricht und Aktion verbunden werden',
    ActionBetweenConditionCondition:
      'Aktion kann nicht zwischen Condition und Condition verbunden werden',
    ActionBetweenConditionAction:
      'Aktion kann nicht zwischen Condition und Aktion verbunden werden',
    ConditionNotWithAction:
      'Condition kann nicht mit einer Aktion verbunden werden',
    StandaloneNotUsed:
      'Einige eigenständige Nachrichten wurden nicht verwendet',
    StandaloneNotUsedSaveDelete:
      'Möchten Sie diese ungenutzten eigenständigen Nachrichten speichern oder löschen?',
    SwitchToFlowchart: 'Bitte wechseln Sie zum Reiter Flowchart',
    SwitchToFlowchartInfo:
      'Wenn Sie das aktuelle Stellenangebot speichern möchten, wechseln Sie bitte zum Reiter Flowchart.',
    MessageNoConnection: 'Einige Nachrichten wurden nicht verbunden',
    ConnectAllMessage: 'Bitte verbinden Sie alle Nachrichten.',
    MessageConditionActionError:
      'Einige Nachrichten, Conditionen oder Aktionen enthalten Fehler',
    MessageConditionActionErrorInfo:
      'Bitte überprüfen Sie alle Nachrichten, Conditionen und Aktionen.',
    LineError: 'Einige Verbindungen enthalten Fehler',
    LineErrorInfo: 'Bitte überprüfen Sie alle Verbindungen.',
    FlowchartEmpty: 'Flowchart ist leer',
    FlowchartEmptyInfo: 'Flowchart darf nicht leer sein.',
    SelectMode: 'Auswahlmodus',
    DragMode: 'Ziehen-Modus',
    UndoMessage: 'Nachricht rückgängig machen',
    RedoMessage: 'Nachricht wiederherstellen',
    UndoFlowchart: 'Flowchart rückgängig machen',
    RedoFlowchart: 'Flowchart wiederherstellen',
    ZoomOut: 'Verkleinern',
    ZoomIn: 'Vergrößern',
    RemoveFlowchart: 'Flowchart entfernen',
    AddNewFlowchart: 'Neues Flowchart hinzufügen',
    CreateANewNode: 'Neuen Knoten erstellen',
    FullScreenMode: 'Vollbildmodus',
    DuplicateFlowchart: 'Aktuelles Flowchart duplizieren',
    ResetFlowchart: 'Aktuelles Flowchart zurücksetzen',
    SameSourceTarget: 'Die Quelle und das Ziel dürfen nicht gleich sein.',
    ConditionActionOrderWrong:
      'Die Reihenfolge von Condition oder Aktion ist falsch.',
    ConditionSameValue:
      'Die Condition hat denselben Wert wie die andere Condition.',
    RemoveFailedMessage:
      'Bitte entferne die fehlgeschlagenen Nachrichten im Flussdiagramm, bevor du einen neuen Knoten hinzufügst.',
    BothMessageSame:
      'Beide Nachrichten sind identisch, bitte entferne eine davon.',
    // matching.ts
    SearchInAllColumns: 'Suche in allen Spalten...',
    AnalysiereAnzeigenMitAI: 'Analysiere Anzeigen mit AI',
    AnalysiereKandidatenMitAI: 'Analysiere Kandidaten mit AI',
    StartMatchesWithAI: 'Starte Matches mit AI',
    BlacklistAbgleichen: 'Blacklist abgleichen',
    Matches: 'Matches',
    Beschäftigungsgruppe: 'Beschäftigungsgruppe',
    Quote: 'Quote',
    keineMatchesText: 'Keine Matches gefunden',

    //applicants-downloader.html
    AngabenZurPerson: 'Angaben zur Person',
    Geschlecht: 'Geschlecht',
    Adresse: 'Adresse',
    Geburtsland: 'Geburtsland',
    Geburtsort: 'Geburtsort',
    Staatsangehörigkeit: 'Staatsangehörigkeit',
    Sprachen: 'Sprachen',
    BestätigungscodeSMS: 'Bestätigungscode SMS',
    EmailBestätigt: 'Email bestätigt',
    KFZ: 'KFZ',
    Führerschein: 'Führerschein',
    EMailVonMONAGesendet: 'E-Mail von MONA gesendet',
    SMSVonMONAGesendet: 'SMS von MONA gesendet',
    TelefonanrufVonMONAGesendet: 'Telefonanruf von MONA gesendet',
    Ausbildung: 'Ausbildung',
    Monate: 'Monate',
    Abschluss: 'Abschluss',
    höchsterAbschluss: 'höchster Abschluss',
    Hauptschulabschluss: 'Hauptschulabschluss',
    MittlereReife: 'Mittlere Reife',
    OhneAbschluss: 'Ohne Abschluss',
    Abitur: 'Abitur',
    höchsteAusbildung: 'höchste Ausbildung',
    ohneAusbildung: 'ohne Ausbildung',
    Berufsausbildung: 'Berufsausbildung',
    mitAbschluss: 'mit Abschluss',
    Bachelor: 'Bachelor',
    Promotion: 'Promotion',
    Diplom: 'Diplom',
    Meister: 'Meister',
    Bemerkungen: 'Bemerkungen',
    Qualifikationen: 'Qualifikationen',
    Vorschläge: 'Vorschläge',
    Match: '- Match',
    Berufserfahrung: 'Berufserfahrung',
    Sprachtest: 'Sprachtest',
    GrammatikUndSatzbau: 'Grammatik und Satzbau',
    Wortschatz: 'Wortschatz',
    KohärenzUndKlarheit: 'Kohärenz und Klarheit',
    Anmerkungen: 'Anmerkungen',
    Talent360Info: 'Talent360 Info',
    Einsatzort: 'Einsatzort',
    Kandidat: 'Kandidat',
    BewerberLog: 'Bewerber Log',
    MonaLog: 'MONA Log',
    TranskriptionDesVideos: 'Transkription des Videos.',
    VideoAntwort: 'Video Antwort',
    TranskriptionDesAudios: 'Transkription des Audios.',
    EigeneFelder: 'Eigene Felder',
    EinstellungstestErgebnisse: 'Einstellungstest Ergebnisse',
    Punkte: 'Punkte',
    Aufgabe: 'Aufgabe',
    erreichtePunkte: 'erreichte Punkte',
    keineDatenVorhanden: 'keine Daten Vorhanden',

    //applicant-info.html
    Schließen: 'Schließen',
    Archivieren: 'Archivieren',
    Editieren: 'Editieren',
    Exportieren: 'Exportieren',
    EinstellungstestSenden: 'Einstellungstest senden',
    VertragErstellen: 'Vertrag erstellen',
    SendeDokumentAnBewerber: 'Sende Dokument an Bewerber',
    KomplettPDFAbrufen: 'Komplett-PDF abrufen',
    ProzessStarten: 'Prozess starten',
    Stufe2: 'Stufe 2',
    Stufe3: 'Stufe 3',
    Handy: 'Handy',
    Anruf: 'Anruf',
    LogAlsPDFExportieren: 'Log als PDF exportieren',
    VideoAnsehen: 'Video ansehen',
    eigenesFeldErgänzen: 'eigenes Feld ergänzen',
    Dateien: 'Dateien',
    Dateiname: 'Dateiname',
    EMailSchicken: 'E-Mail schicken',
    SMSSchicken: 'SMS schicken',
    anrufenLassen: 'anrufen lassen',
    KundeWarSehrZufrieden: 'Kunde war sehr zufrieden...',
    abgeschlosseneBerufsausbildungAlsMechaniker:
      'abgeschlossene Berufsausbildung als Mechaniker...',
    Erfahrung: 'Erfahrung',
    zehnJahreErfahrung: '10 Jahre Erfahrung...',
    Unternehmen: 'Unternehmen',
    FieldName: 'Feld Name',
    FieldValue: 'Feld Wert',
    Remove: 'Entfernen',
    FeldErgänzen: 'Feld ergänzen',
    Submit: 'Bestätigen',
    DateiHierherZiehen: 'Datei hierher ziehen',
    ProfilErstellt: 'Profil erstellt',
    noData: 'Keine Daten verfügbar',
    erfolg: 'Erfolg',
    fehler: 'Fehler',
    dateDesc: 'Datum (Absteigend)',
    dateAsc: 'Datum (Aufsteigend)',
    typeDesc: 'Typ (Absteigend)',
    typeAsc: 'Typ (Aufsteigend)',

    //applicants.html
    ArchivierteAusblenden: 'Archivierte ausblenden',
    ArchivierteAnzeigen: 'Archivierte anzeigen',
    AlleZeigen: 'Alle zeigen',
    nichtAlleZeigen: 'nicht alle zeigen',
    Schnellerfassung: 'Schnellerfassung',
    BewerberInDenLetzten30Tagen: 'Bewerber in den letzten 30 Tagen',
    LadeAlle: 'Lade Alle',
    exportExcel: 'Export Excel',
    exportToExcelAlle: 'Export nach Excel - Alle',
    applicantReactivatedSuccessfully: 'Bewerber erfolgreich reaktiviert',
    applicantArchivedSuccessfully: 'Bewerber erfolgreich archiviert',
    systemStatus: 'System Status',

    //reporting.html
    ReportingErstellen: 'Reporting erstellen',
    erstellen: 'Erstellen',
    Export: 'Export',
    OneWeek: 'Woche',
    DateRange: 'Datumsbereich',
    keineReportingText: 'Keine reporting gefunden',
    BitteWählenSieEinZeitraum: 'Bitte wählen Sie ein Zeitraum',
    //upload.html
    BewerberExcelImport: 'Bewerber Excel-Import',
    IndexStellenanzeigen: 'Index Stellenanzeigen',
    TalentionUpload: 'Talention Upload',
    IndexUpload: 'Index Upload',
    BewerberUpload: 'Bewerber Upload',
    ExcelStandardVorlageDownloaden: 'Excel-Standard-Vorlage downloaden',
    BewerberKontaktieren: 'Bewerber kontaktieren',
    BewerberÜbernehmen: 'Bewerber übernehmen',
    BewerberImportListe: 'Bewerber-Import Liste',
    Bewerberin: 'Bewerber/in',
    Mobilnummer: 'Mobilnummer',
    TalentionDatenHochladen: 'Talention Daten hochladen',
    wurdenAusgelesenUndAnalysiertMitKI:
      'wurden ausgelesen und analysiert mit KI',
    IndexAnzeigendatenJSONUpload: 'Index Anzeigendaten JSON Upload',
    Hochladen: 'Hochladen',
    IndexAnzeigendatenJSONUploadError:
      'JSON-Datei kann nicht verarbeitet werden',
    DateiErfolgreichHochgeladen: 'Datei erfolgreich hochgeladen',
    DateiErfolgreichHochgeladenMessage:
      'Es kann bis zu 60 Sekunden zur vollständigen Verarbeitung dauern',
    MandantAuswählen: 'Mandant auswählen',
    MatchingEinstellungen: 'Matching-Einstellungen',
    FragenSuchen: 'Fragen suchen',
    StandardFragen: 'Standard Fragen',
    EigeneFragen: 'Eigene Fragen',
    ausgewählte: 'ausgewählte',
    AusgewählteFragenSpeichern: 'Ausgewählte Fragen speichern',
    //applicant-email.html
    EmailAutomatisierungfuerBewerber:
      'Email Automatisierung für Bewerber - Interviews',
    Modelauswaehlen: 'Modell auswählen',
    Vorlage: 'Vorlage',
    Testmail: 'Testmail',
    TestmailAnSchicken: 'Testmail schicken an',
    BewerberDaten: 'Bewerber-Daten',
    BewerberDatenAbrufen: 'Bewerber-Daten abrufen',
    BewerberImport: 'Bewerber-Import',
    BewerberDatenHochladen: 'Bewerber-Daten hochladen',
    VideosGenerierenFuer: 'Videos generieren für',
    AlleEmailsSchicken: 'Alle Emails schicken',

    //data-warehouse.html
    SelectAndConnectEndpoints: 'Endpunkte auswählen und verbinden',
    SelectSourceEndpoint: 'Wählen Sie Quellendpunkt aus',
    SelectDestinationEndpoint: 'Wählen Sie Zielendpunkt aus',
    ConnectEndpoints: 'Endpunkte verbinden',

    //settings.html
    DatenImport: 'Daten Import',
    DataWarehouse: 'Data Warehouse',
    Integrationen: 'Integrationen',
    Blacklist: 'Blacklist',
    BewerberLeadgenerierung: 'Bewerber-Leadgenerierung',
    KundenLeadgenerierung: 'Kunden-Leadgenerierung',
    KIStudio: 'KI-Studio',
    SucheNachNameOderAktionOderMedium:
      'Suche nach Name oder Aktion oder Medium',

    //agent-edit.html
    Agentbearbeiten: 'Agent bearbeiten',
    AgentennamenEingeben: 'Agentennamen eingeben',
    Ausführungsrhythmus: 'Ausführungsrhythmus',
    WähleRhythmus: 'Wähle den Rhythmus',
    Manuell: 'Manuell',
    Wöchentlich: 'Wöchentlich',
    CustomInterval: 'Benutzerdefiniertes Intervall',
    ZeitfürtäglicheAusführung: 'Zeit für tägliche Ausführung',
    WochentagefürAusführung: 'Wochentage für Ausführung',
    WähleWochentage: 'Wähle Wochentage',
    Montag: 'Montag',
    Dienstag: 'Dienstag',
    Mittwoch: 'Mittwoch',
    Donnerstag: 'Donnerstag',
    Freitag: 'Freitag',
    Samstag: 'Samstag',
    Sonntag: 'Sonntag',
    ZeitfürwöchentlicheAusführung: 'Zeit für wöchentliche Ausführung',
    Intervallbeispiel: 'Intervall (z.B. alle 6 Stunden)',
    IntervallinStunden: 'Intervall in Stunden',
    Aufgabehinzufügen: 'Aufgabe hinzufügen',
    Aufgabentitel: 'Aufgabentitel',
    Aufgabename: 'Aufgabenname',
    Textaufforderung: 'Textaufforderung',
    AngehängtesDokument: 'Angehängtes Dokument',
    agentUpdateSuccessText: 'Agent erfolgreich aktualisiert.',
    agentUpdateErrorText: 'Fehler beim Aktualisieren des Agenten.',
    agentLoadErrorText: 'Fehler beim Laden der Agenten.',
    agenterstellen: 'Agent erstellen',
    agentSavedSuccessfully: 'Agent erfolgreich gespeichert.',
    agentSaveError: 'Agent konnte nicht gespeichert werden.',
    folderNameRequired: 'Der Ordnername darf nicht leer sein.',

    //blacklist.html
    emailBlacklist: 'E-Mail Blacklist',
    BlacklistanzeigenKunden: 'Blacklist anzeigen Kunden',
    Blacklisthochladen: 'Blacklist hochladen',
    BlacklistLength: 'Kunden auf der Schwarzen Liste',
    emailAdress: 'E-Mail Adresse',
    AddBlacklistMember: 'Blacklist-Mitglied hinzufügen',
    uploadlimit: 'maximal 100 auf einmal hochladen',
    uploadInstruction:
      'bei großen Uploads eine E-Mail schicken an support@mona-ai.de mit der Datei im JSON, Excel oder csv-Format',
    Clear: 'Leeren',
    Neuhochgeladen: 'Neu hochgeladen wurden: ',
    noDataFound: 'keine Daten gefunden',
    noNewEntriesFound: 'keine neuen Einträge gefunden',
    uploadTooManyEntries:
      'mehr als 100 Einträge. Liste wird nicht hochgeladen. Bitte nur neue Einträge hochladen.',
    searchPlaceholder: 'Suchwort eingeben',
    notInBlacklistYet: ' ist noch nicht in Blacklist enthalten',
    discardChanges: 'Änderungen verwerfen?',
    wirdNichtGespeichert: 'Änderungen werden verworfen und nicht gespeichert.',
    discard: 'Verwerfen',
    searchRequirement: 'Suchanforderung',
    searchMinimumChars: 'Bitte geben Sie mindestens 3 Zeichen ein, um zu suchen',
    searching: 'Suche läuft...',
    searchError: 'Fehler beim Suchen aufgetreten. Bitte versuchen Sie es erneut.',
    uploading: 'Hochladen...',
    uploadSuccess: 'Upload erfolgreich',
    newEmailsAdded: 'Neue E-Mails hinzugefügt',
    duplicatesSkipped: 'Duplikate übersprungen',
    invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    checking: 'Überprüfung läuft...',
    emailExists: 'E-Mail existiert bereits',
    emailAlreadyInBlacklist: 'Diese E-Mail ist bereits in der Blacklist',
    adding: 'Hinzufügen...',
    emailAddedSuccessfully: 'E-Mail erfolgreich zur Blacklist hinzugefügt',
    errorAddingEmail: 'Fehler beim Hinzufügen der E-Mail zur Blacklist',
    enterEmail: 'E-Mail-Adresse eingeben',
    addToBlacklist: 'Zur Blacklist hinzufügen',
    addEmailInfo: 'Geben Sie eine gültige E-Mail-Adresse ein, um sie zur Blacklist hinzuzufügen. E-Mails auf der Blacklist werden automatisch herausgefiltert.',
    searchButtonNotice: 'Geben Sie mindestens 3 Zeichen ein und klicken Sie auf die Suchen-Schaltfläche',
    maxShown: 'max. angezeigt',
    bulkUploadGuide: 'Bulk-Upload-Anleitung',
    overview: 'Übersicht',
    bulkUploadOverview: 'Laden Sie bis zu 100 E-Mail-Adressen auf einmal über Datei-Upload oder manuelle Texteingabe hoch.',
    uploadMethods: 'Upload-Methoden',
    method1FileUpload: 'Methode 1: Datei-Upload (Empfohlen)',
    supportedFormats: 'Unterstützte Formate',
    excelFormat: 'Excel-Format',
    excelFormatDesc: 'E-Mails in die erste Spalte eintragen, eine pro Zeile',
    steps: 'Schritte',
    fileUploadSteps: '1) Klicken Sie auf "Datei auswählen" 2) Wählen Sie Ihre Datei aus 3) Klicken Sie auf Upload-Button',
    method2ManualEntry: 'Methode 2: Manuelle Texteingabe',
    manualEntryDesc: 'Geben Sie E-Mails direkt in das Textfeld unten ein oder fügen Sie sie ein',
    format: 'Format',
    oneEmailPerLine: 'Eine E-Mail pro Zeile, keine Leerzeichen, muss @ und . enthalten',
    importantRules: 'Wichtige Regeln',
    rule1: 'Maximal 100 E-Mails pro Upload',
    rule2: 'E-Mails müssen @ und . Symbole enthalten',
    rule3: 'Keine Leerzeichen in E-Mail-Adressen erlaubt',
    rule4: 'Duplikate werden automatisch übersprungen',
    rule5: 'Für größere Uploads kontaktieren Sie support@mona-ai.de',
    exampleFormat: 'Beispielformat',
    chooseUploadMethod: 'Upload-Methode wählen',
    fileUpload: 'Datei-Upload',
    supportedFiles: 'Unterstützt: .xlsx, .xls, .json Dateien',
    manualEntry: 'Manuelle Eingabe',
    manualEntryPlaceholder: 'E-Mail-Adressen eingeben, eine pro Zeile:\nexample1@domain.com\nexample2@company.org\nexample3@website.net',


    //interview-cohorts
    InterviewCohorts: 'Interview-Kohorten',
    DropoutAnalysis: 'Abbruchanalyse',
    ApplicantFlow: 'Bewerberfluss',
    applicants: 'Bewerber',
    droppedOff: 'abgebrochen',
    completed: 'abgeschlossen',
    CriticalDropoutZone: 'Kritische Abbruchzone',
    ModerateDropoutZone: 'Moderate Abbruchzone',
    LowDropoutZone: 'Geringe Abbruchzone',
    DropoffRate: 'Abbruchrate',
    Stage: 'Phase',
    Total: 'Gesamt',
    Dropped: 'Abgebrochen',
    Completed: 'Abgeschlossen',
    ApplicantsWhoDroppedOffAt: 'Bewerber, die abgebrochen haben bei',
    InterviewDropoutAnalysis: 'Interview-Abbruchanalyse',

    // Workspace translations
    WorkspaceTitle: "Felix's Workspace",
    WhatsOnYourMind: "What's on your mind today?",
    NewIdeas: '12 new ideas',
    CheckingQuestions: 'Checking questions…',
    AIEmployees: 'AI Employees',

    // Agent names
    AgentFields: 'Fields',
    AgentVine: 'Vine',
    AgentBuzz: 'Buzz',
    AgentCedar: 'Cedar',
    AgentFinn: 'Finn',
    AgentOliver: 'Oliver',
    AgentBloom: 'Bloom',
    AgentMarket: 'Market',
    AgentSparkle: 'Sparkle',
    AgentFeast: 'Feast',
    AgentSugar: 'Sugar',
    AgentSwift: 'Swift',
    AgentGreen: 'Green',
    AgentEco: 'Eco',
    AgentSpark: 'Spark',
    AgentFlow: 'Flow',
    AgentMason: 'Mason',
    AgentArtie: 'Artie',
    AgentRidge: 'Ridge',
    AgentBrick: 'Brick',
    AgentTile: 'Tile',
    AgentCool: 'Cool',
    AgentCycle: 'Cycle',
    AgentCraft: 'Craft',
    AgentStitch: 'Stitch',
    AgentGem: 'Gem',
    AgentDough: 'Dough',
    AgentGourmet: 'Gourmet',
    AgentForge: 'Forge',
    AgentClay: 'Clay',
    AgentWeave: 'Weave',
    AgentGuard: 'Guard',

    // Agent roles
    RoleFarmer: 'Farmer',
    RoleVineyardOwner: 'Vineyard Owner',
    RoleBeekeeper: 'Beekeeper',
    RoleForester: 'Forester',
    RoleFishFarmer: 'Fish Farmer',
    RoleOrganicFarmer: 'Organic Farmer',
    RoleHorticulturist: 'Horticulturist',
    RoleMarketTrader: 'Market Trader',
    RoleCleaningServiceProvider: 'Cleaning Service Provider',
    RoleCaterer: 'Caterer',
    RolePastryChef: 'Pastry Chef',
    RoleCourierServiceOperator: 'Courier Service Operator',
    RoleLandscapingServiceOwner: 'Landscaping Service Owner',
    RoleWasteManagementContractor: 'Waste Management Contractor',
    RoleElectrician: 'Electrician',
    RolePlumber: 'Plumber',
    RoleCarpenter: 'Carpenter',
    RolePainterAndDecorator: 'Painter and Decorator',
    RoleRoofer: 'Roofer',
    RoleBricklayer: 'Bricklayer',
    RoleTiler: 'Tiler',
    RoleHVACTechnician: 'HVAC Technician',
    RoleBicycleRepairTechnician: 'Bicycle Repair Technician',
    RoleFurnitureMaker: 'Furniture Maker',
    RoleTailor: 'Tailor',
    RoleJeweler: 'Jeweler',
    RoleBaker: 'Baker',
    RoleSpecialtyFoodProducer: 'Specialty Food Producer',
    RoleMetalworker: 'Metalworker',
    RoleCeramicist: 'Ceramicist',
    RoleTextileManufacturer: 'Textile Manufacturer',
    RoleSecurityServicesContractor: 'Security Services Contractor',
    MehrErfahren: 'Mehr erfahren',
    HilfeNichtVerfügbar: 'Hilfe für diesen Bereich ist nicht verfügbar.',
    HelpDashboardOverview: 'Das Dashboard zeigt Ihnen eine Übersicht über Ihre wichtigsten Kennzahlen, aktuelle Stellenanzeigen und Bewerbungen.',
    HelpJobOfferTitle: 'Geben Sie hier den Titel Ihrer Stellenanzeige ein. Dieser wird in Suchergebnissen und auf Ihrer Karriereseite angezeigt.',
    HelpJobOfferLanguage: 'Wählen Sie die Hauptsprache für Ihre Stellenanzeige. Diese bestimmt die Sprache der automatisch generierten Inhalte.',
    HelpJobOfferAvatar: 'Wählen Sie einen Avatar für Ihre KI-generierten Videos aus. Der Avatar wird Ihre Stellenanzeige präsentieren.',
    HelpApplicantFiltering: 'Nutzen Sie die Filter, um Bewerber nach Status, Qualifikationen oder anderen Kriterien zu sortieren.',
    HelpWorkflowBasic: 'Grundlegende Workflows automatisieren einfache Aufgaben wie E-Mail-Versendung bei Bewerbungseingang.',
    HelpWorkflowAdvanced: 'Erweiterte Workflows bieten komplexe Automatisierung mit Bedingungen und mehreren Aktionen.',
    HelpReportingFilters: 'Verwenden Sie die Filter, um Berichte für bestimmte Zeiträume und Stellenanzeigen zu erstellen.',
    HelpProfileSettings: 'Hier können Sie Ihre Unternehmenseinstellungen, Sprache und Integrationen konfigurieren.',
    HelpDashboardCommunication: 'Übersicht über versendete E-Mails, SMS und Anrufe im Verhältnis zu verfügbaren Kontingenten.',
    HelpDashboardWorkflows: 'Zeigt aktive Workflows im Verhältnis zur maximalen Anzahl verfügbarer Workflows.',
    HelpDashboardApplicants: 'Zeigt die Anzahl der Bewerber im Verhältnis zum maximalen Limit an.',
    TooltipExportApplicants: 'Export selected applicant data as Excel file for reporting and analysis',
    TooltipReloadApplicants: 'Reload the applicant list and refresh all data',
    TooltipArchiveApplicants: 'Archive selected applicants for long-term retention',
    TooltipDeleteApplicants: 'Permanently delete selected applicants from the system',
    TooltipExportJobOffers: 'Export job offers as JSON file for system integration',
    TooltipReloadJobOffers: 'Reload the job offers list and refresh all data',
    TooltipReactivateJobOffers: 'Reactivate accidentally deleted job offers',
    TooltipDeleteJobOffers: 'Permanently delete selected job offers',
    TooltipShowContracts: 'Open direct access to legal documents and contracts',
    TooltipImportJobOffers: 'Import job offers from JSON files for system integration',
    TooltipCreateJobOffer: 'Create new job offers for open positions',
    TooltipExportAllApplicants: 'Export all applicant data as Excel file',
    TooltipFilterApplicants: 'Use filters to sort and manage applicants by status and criteria',
    reload: 'Neu Laden',
    MitInterview: 'Mit Interview',
    Einzelkontaktierung: 'Einzelkontaktierung'
  };
}
